import React, { useEffect, useState } from "react";
import api from "../../seller-apis/api";
import {
  draftedProducts,
  pendingProducts,
} from "../../seller-apis/apidataField";
import CustomModal from "../common/CustomModal";
import "./inventory.css";
import PaginationCom from "../common/Pagination";
import { NavLink } from "react-router-dom";
import SendRequestModal from "./SendRequestModal";
import axios from "axios";
import { useDispatch } from "react-redux";
import { useAlert } from "react-alert";
import servicesApi from "../../seller-apis/servicesApi";
import VideoModalUpload from "./uploadVideoModal";
import ImageModalUpload from "./uploadImageModal";
import { Actions } from "../../Actions/Actions";
import variables from '../../Variables.json'
function DraftedProduct() {
  const dispatch=useDispatch();
  var imgUrls = [];
  let filter = {
    pageNo: "1",
  };
  const [showModal, setShowModal] = useState(false);
  const [showRequestModal, setShowRequestModal] = useState(false);
  const [showVideoModal, setShowVideoModal] = useState(false);
  const [showImageModal, setShowImageModal] = useState(false);
  const [draftProduct, setDraftProductsList] = useState(null);
  const [newCurrPage, setnewCurrPage] = useState(1);
  const [paginationData, setPaginationData] = useState(1);

  const [compforPaginationNew, setcompforPaginationNew] = useState("Drafted");
  const [newRecords, setnewRecords] = useState();
  const [selectedId, setSelectedId] = useState(null);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [images, setImages] = useState(null);
  const [categories, setCategories] = useState([]);
  const GSTArray = variables?.variables?.gstValues;
  useEffect(async () => {
    const ress = await servicesApi.categories.categoryTree({});
    let catList = ress.data;
    setCategories(catList);
    getDraftedProduct();
  }, []);
  
  const handleOpenModal = (id) => {
    setSelectedId(id);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setShowRequestModal(false);
    setShowVideoModal(false);
    setShowImageModal(false);
  };
  const handleConfirm = () => {
    api.product
      .deleteNewProductBulk(selectedId)
      .then((res) => {
        Actions.QCRequestSend(dispatch,{status:true,type:'delete'});
        paginate(paginationData);
        // getDraftedProduct();
        handleCloseModal();
      })
      .catch((err) => console.log(err));
  };

  const getDraftedProduct = () => {
    let filterProduct = {
      pageNo: 1,
      filters: { "status-id": "draft" },
    };
    api.product
      .newProductsRetrieveall(draftedProducts(filterProduct))
      .then((res) => {
        setDraftProductsList(res.products);

        setnewRecords(res.totalRecords);
      })
      .catch((err) => console.log(err));
  };
  const imageUrl = (images) => {
    let imageUrlDomain = "",
      imageUrl = "https://s3.toolsvilla.com/";
    imageUrlDomain = images.find((item) => !item.image.includes("toolsvilla"));

    if (imageUrlDomain) {
      return imageUrl + imageUrlDomain.image;
    }
    imageUrlDomain = images.find((item) => item.image.includes("toolsvilla"));
    if (imageUrlDomain) {
      return imageUrlDomain.image;
    }
    return null;
  };
  const addImage = (e, product) => {
    let imageFinal;
    let registerImage;
    let vendorId = product.vendor;
    let extension = e.target.files[0].name.slice(
      e.target.files[0].name.lastIndexOf(".")
    );
    let comImg = e.target.files[0].name.replace(/[^\w]/g, "");
    imageFinal = "img_" + vendorId + "_" + comImg + extension;
    registerImage = e.target.files[0];
    var data = {
      imageName: imageFinal,
      type: "products",
    };
    api.product
      .saveProductImage(data)
      .then((res) => {
        axios({
          method: "put",
          url: res.data,
          data: registerImage,
          onUploadProgress: (data) => {
            //Set the progress value to show the progress bar
            // setimgprogress(Math.round((100 * data.loaded) / data.total));
          },
        })
          .then((response) => {
            let data = {
              baseImage: true,
              smallImage: false,
              thumbnail: false,
              visible: false,
              image: "products/" + imageFinal,
              label: imageFinal,
            };
            imgUrls.push(data);
            addProduct(product);
          })
          .catch((error) => {
            console.log(error);
          });
      })
      .catch((err) => console.log(err));
  };
  const alert = useAlert();
  const addProduct = (productData) => {
    productData["images"] = imgUrls;

    api.product
      .addNewProduct(productData)
      .then((res) => {
        alert.success("Product added successfully");
        getDraftedProduct();
        // if (NewVendTotalprcount === 0) {
        //   NewVendTotalprcount = NewVendTotalprcount + 1;
        //   pkgData.product = res._id;
        //   window.location.assign("/regprosuccess");
        // } else {
        //   window.location.assign("/my-inventory/new_product_request/manual");
        // }
      })
      .catch((err) => {
        console.log(err);
        alert.error("Failed to add product");
      });
  };

  const updateStatus = (productData) => {
    productData["status"] = "pending";

    api.product
      .addNewProduct(productData)
      .then((res) => {
        alert.success("You request is sent for QC ");
        Actions.QCRequestSend(dispatch,{status:true,type:'update'});
        paginate(paginationData);
        // getDraftedProduct();
        // if (NewVendTotalprcount === 0) {
        //   NewVendTotalprcount = NewVendTotalprcount + 1;
        //   pkgData.product = res._id;
        //   window.location.assign("/regprosuccess");
        // } else {
        // window.location.assign("/my-inventory/new_product_request/manual");
        // }
      })
      .catch((err) => {
        console.log(err);
        alert.error("Failed to add product");
      });
  };

  function paginate(data) {
    setnewCurrPage(data.number);
    setPaginationData(data);
    let filterProduct = {
      pageNo: data.number,
      filters: { status: "draft" },
    };
    api.product
      .newProductsRetrieveall(draftedProducts(filterProduct))
      .then((res) => {
        setDraftProductsList(res.products);
        setnewRecords(res.totalRecords);
        if(res.products?.length==0){
          getDraftedProduct();
        }
      })
      .catch((err) => console.log(err));
  }
  const getCategoryame = (categortyTree, categoryId) => {
    if (categortyTree._id === categoryId) {
      return categortyTree;
    }

    if (categortyTree?.subCategories) {
      for (let child of categortyTree?.subCategories) {
        const result = getCategoryame(child, categoryId);
        if (result) {
          return result;
        }
      }
    }
    return null;
  };

  return (
    <>
      <div className="drafted-prod table-responsive">
        <table className="drafted-table">
          <tr>
            <th style={{ width: "25%" }}>Product Name</th>
            <th>Image</th>
            <th>Video</th>
            <th style={{ width: "10%" }}>Category</th>
            <th>Transfer Price (Incl GST)</th>
            <th>Brand</th>
            <th>Packages</th>
            <th>Action</th>
          </tr>
          {draftProduct &&
            draftProduct.map((product, index) => {
              return (
                <tr key={index}>
                  <td>{product.productName}</td>
                  <td>
                    {!product.images ||
                    (product.images && product?.images.length == 0) ? (
                      <div className="no-data">
                        {/* No Media Available, Please add Product Image & Video
                        from Edit Product Option */}
                        <label
                          className="upload-file img-upload file-upload"
                          onClick={() => {
                            setShowImageModal(true);
                            setSelectedProduct(product);
                          }}
                        >
                          <img src="/upload.webp" alt="upload" />
                          Upload
                          {/* <input
                            id={`file-upload-input${index}`}
                            onChange={(e) => {
                              addImage(e,product);
                            }}
                            type="file"
                          /> */}
                        </label>
                      </div>
                    ) : (
                      <img
                        src={imageUrl(product.images)}
                        alt={product.productName}
                        height={50}
                        className="mw-100"
                      />
                    )}
                  </td>
                  <td>
                    {!product.videos ||
                    (product.videos && product.videos[0]!=null && product?.videos.length > 0) ? (
                      <div class="video-container">
                          {product.videos[0].includes("http") ? (
                            <a href={product.videos[0]} target="_blank" >{product.videos[0].substring(5, 0)}<img style={{width:'30%'}} src="/opennewtab.png" alt="new tab icon" /></a>
                          ) : (
                            <video controls>
                            <source
                              src={`https://media.toolsvilla.com/products/${product.videos[0]}`}
                              type="video/mp4"
                            />
                          Your browser does not support the video tag.
                        </video>
                          )}
                      </div>
                    ) : (
                      <div className="no-data">
                        {/* No Media Available, Please add Product Image & Video
                  from Edit Product Option */}
                        <label
                          className="upload-file img-upload file-upload cursor-popinter"
                          onClick={() => {
                            setShowVideoModal(true);
                            setSelectedProduct(product);
                          }}
                        >
                          <img src="/upload.webp" alt="upload" />
                          add
                        </label>
                      </div>
                    )}
                  </td>
                  <td>
                    {product.categories &&
                      getCategoryame(
                        categories,
                        product.categories[product?.categories?.length - 1]
                      )?.categoryName}
                  </td>
                  <td>
                    {product.price ?
                    <>
                      <div className="price">&#8377; {product.price}</div>
                        <div className="gst">
                          (incl.
                          {GSTArray.map(Number).includes(Number(product.taxClass))
                            ? Number(product.taxClass)
                            : 0}
                          % GST)
                        </div>
                    </>
                    : ""}
                  </td>
                  <td>{product.brandName ? product.brandName : ""}</td>
                  <td>
                    {product?.pkgs.length > 0  ? (
                      "Packages added"
                    ) : (
                      <NavLink target={'_blank'} to={"/form/" + product._id+"/draft"}>
                        <label className="mb-2 upload-file img-upload file-upload cursor-popinter">
                          <div className="label">Add Packages</div>
                        </label>
                      </NavLink>
                    )}
                  </td>
                  <td>
                    <div className="button-container">
                      <div className="action-buttons">
                        <NavLink  target={'_blank'} to={"/edit-product1/" + product._id}>
                          <button className="mb-2">
                            <div className="label">Edit Product</div>
                            <div className="edit-icon">
                              <img src="/edit.webp" alt="icon" />
                            </div>
                          </button>
                        </NavLink>
                        {!product?.images || !product?.taxClass || !product?.price || !product?.manufacturer || product?.metaInformation?.keywords.length==0 || !product?.description || (!product?.images || product.images.length==0) || !product?.originCountry || !product?.stock ? (
                          <button
                            className="request-active"
                            onClick={() => {
                              setShowRequestModal(true);
                              setSelectedProduct(product);
                            }}
                          >
                            <div className="label">Send Request</div>
                            <div className="edit-icon">
                              <img src="/right-arrow-white.webp" alt="icon" />
                            </div>
                          </button>
                        ) : (
                          <button
                            className="request-active"
                            onClick={() => {
                              updateStatus(product);
                            }}
                          >
                            <div className="label">Send Request</div>
                            <div className="edit-icon">
                              <img src="/right-arrow.webp" alt="icon" />
                            </div>
                          </button>
                        )}
                      </div>
                      <div className="delete-icon">
                        <img
                          src="/delete.webp"
                          alt="icon"
                          onClick={() => handleOpenModal(product._id)}
                        />
                      </div>
                    </div>
                  </td>
                </tr>
              );
            })}
        </table>
      </div>
      <PaginationCom
        number={newRecords}
        paginate={paginate}
        activ={newCurrPage}
        comp={compforPaginationNew}
      />

      <CustomModal
        show={showModal}
        handleConfirm={handleConfirm}
        handleClose={handleCloseModal}
      />
      {selectedProduct ? (
        <>
          <SendRequestModal
            show={showRequestModal}
            handleConfirm={handleConfirm}
            product={selectedProduct}
            handleClose={handleCloseModal}
          />
          <VideoModalUpload
            show={showVideoModal}
            handleConfirm={handleConfirm}
            product={selectedProduct}
            handleClose={handleCloseModal}
          />
          <ImageModalUpload
            show={showImageModal}
            handleConfirm={handleConfirm}
            product={selectedProduct}
            handleClose={handleCloseModal}
          />
        </>
      ) : (
        ""
      )}
    </>
  );
}

export default DraftedProduct;
